import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { captureException } from '@sentry/react-router';

import { TableOfContents as TableOfContentsModule, type TocHeading } from '@cx-modules/table-of-contents';

type Props = {
  // Current page path (with repub prefix). Passed to the module so ToC links are
  // path-qualified and resolve correctly under the page's <base href>.
  currentPathWithRepub?: string;
  display?: boolean;
  displayState?: 'collapsed' | 'expanded';
  headings?: TocHeading[] | null;
  title?: string;
};

export const TableOfContents = ({ currentPathWithRepub, display, displayState, headings, title }: Props) => {
  const { t } = useTranslation('label');
  // Contentful-supplied title wins; otherwise the translated label.
  const resolvedTitle = title?.trim() || t('CX_TABLE_OF_CONTENTS_HEADER');

  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        captureException(error);
        return null;
      }}
    >
      <TableOfContentsModule
        display={display}
        displayState={displayState}
        headings={headings}
        pathname={currentPathWithRepub}
        title={resolvedTitle}
      />
    </ErrorBoundary>
  );
};
